export const kernCounty = {
  name: `kernCounty`,
  sql: `
    SELECT * FROM solano_county
    `,
  cartoCSS: `
    #layer {
        polygon-fill: #ffffff;
        polygon-opacity: 0;
    }
    #layer::outline {
        line-width: 1;
        line-color: #000;
        line-opacity: 1;
        ::inline {
          line-width: 4;
          line-color: #2d302d;
          line-opacity: 0.25;
          line-join: round;
          line-offset: -3;
      }
    }
  `,
  viz: `
    color: opacity(#2d302d, 0)
    strokeColor: #2d302d
    `
}